import React, { useEffect, useState } from 'react'
import { ImagePath } from '../../assets/ImagePath'
import { getFileBaseUrl } from '../../services/FilesService';
import { getUserInitials, isValidImageUrl } from '../../utils/general';
import { UserServiceClientApi } from '../../services/api/UserApiServices';
import { setSelectedGroupChatparticipants } from '../../state/actions/chats';
import UserConfirmationModal from '../../components/ui/Modals/ModalMessages/UserConfirmationModal';
import { useDispatch } from 'react-redux';

const Memberlist = ({ selectedContactDetails, selectedGroupChatParticipants, userID,
    editChannel,
    searchMembers, channelAdmins, isChannelAdmin, isGroupOwner, setEditGroupModal }) => {
    const [showAll, setShowAll] = useState(false);
    const [avatarMap, setAvatarMap] = useState({});
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openRemoveModal, setOpenRemoveModal] = useState(false);
    const [openAdminModal, setOpenAdminModal] = useState(false);
    const visibleContacts = showAll ? selectedGroupChatParticipants : selectedGroupChatParticipants.slice(0, 2);
    const dispatch = useDispatch();

    const isUserAlreadyAdmin = (userId) => {
        return channelAdmins.some(admin => admin.userId === userId);
    };

    const handleRemoveUser = async (userIdToRemove) => {
        const updatedUsers = selectedGroupChatParticipants.filter(
            (member) => member.userId !== userIdToRemove
        );

        const payload = {
            channelName: selectedContactDetails?.channelName,
            userDomain: selectedContactDetails?.userDomain || "onship",
            userIds: updatedUsers.map((u) => u.userId),

        };

        try {
            const response = await UserServiceClientApi.updateParticipants(payload);
            if (response) {
                dispatch(setSelectedGroupChatparticipants(updatedUsers))
                setSelectedUserId(null);
            } else {
                console.error("Failed to update participants.");
            }
            setOpenRemoveModal(false)
        } catch (error) {
            console.error("Error removing user:", error);
        }
    };

    const handleMakeAdmin = async (userId) => {
        let obj = {
            channelName: selectedContactDetails?.channelName,
            userDomain: selectedContactDetails?.channelOwner?.userDomain || "onship",
            admins: [userId],
        };
        try {
            UserServiceClientApi.updateChannelAdmin(obj);
            setOpenAdminModal(false)
            setSelectedUserId(null);
        } catch (error) {
            setOpenAdminModal(false)
            setSelectedUserId(null);
        }

    }

    const toggleAdmin = (userId) => {

        const currentAdminIds = channelAdmins.map(admin => admin.userId);

        const isAlreadyAdmin = currentAdminIds.includes(userId);
        const updatedAdminIds = isAlreadyAdmin
            ? currentAdminIds.filter(id => id !== userId)
            : [...currentAdminIds, userId];
        // setAdmins(updatedAdminIds);
        const payload = {
            channelName: selectedContactDetails?.channelName,
            userDomain: selectedContactDetails?.userDomain || "onship",
            admins: updatedAdminIds,

        };

        try {
            UserServiceClientApi.updateChannelAdmin(payload);
            setOpenAdminModal(false)
            setSelectedUserId(null);
        } catch (error) {
            setOpenAdminModal(false)
            setSelectedUserId(null);
        }
    };

    useEffect(() => {
        const loadGroupContactAvatars = async () => {
            const avatars = {};

            await Promise.all(
                selectedGroupChatParticipants?.map(async (member) => {
                    try {
                        const resolvedUrl = await isValidImageUrl(member?.profileImage);
                        if (!resolvedUrl) {
                            const name = member?.userName || "U";
                            avatars[member.userId] = getUserInitials(name);
                        } else {
                            avatars[member.userId] = resolvedUrl;
                        }
                    } catch (err) {
                        console.error(`Error loading avatar for :`, err);
                    }
                })
            );

            setAvatarMap(avatars);
        };

        if (selectedGroupChatParticipants?.length > 0) {
            loadGroupContactAvatars();
        }
    }, [selectedGroupChatParticipants]);

    const closeRemoveModal = () => {
        setOpenRemoveModal(false)
    }
    const closeAdminModal = () => {
        setOpenAdminModal(false)
    }


    return (
        <>
            {/* ---Add Members / Toggle---- */}
            <div className="flex justify-between items-center mt-7 mb-3">
                <div className="flex items-center gap-2">
                    <a href="#">
                        <div className="w-[45px] h-[45px] bg-skyblue rounded-full flex items-center justify-center p-3">
                            <img loading="lazy" src={ImagePath.members} alt="addPeopleIcon" />
                        </div>
                    </a>
                    <span className="text-skyblue text-[14px] font-semibold cursor-pointer" onClick={() => setEditGroupModal(true)}>Add Members</span>
                </div>


            </div>
            <div className="overflow-auto h-[calc(100vh-662px)]">
                {/* ---Members List--- */}
                {visibleContacts
                    ?.filter((contact) => {
                        const name = contact?.userName
                        return name.toLowerCase().includes(searchMembers.toLowerCase());
                    })
                    ?.map((contact) => (
                        <div className="flex items-center justify-between py-[4px] mb-[30px]">
                            <div className="flex items-center gap-[8px]">
                                <div className="relative  w-[45px] h-[45px] bg-[#727484] rounded-full">
                                    {avatarMap[contact?.userId]?.startsWith("http") ? (
                                        <img
                                            src={avatarMap[contact?.userId]}
                                            alt={contact?.userName}
                                            className="h-full w-full rounded-full"
                                        />
                                    ) : (
                                        <div className="rounded-full bg-primary-blue w-[45px] h-[45px] bg-gray-500 flex items-center justify-center text-white text-sm font-[Figtree]">
                                            {avatarMap[contact?.userId]}
                                        </div>
                                    )}
                                    <button className="absolute bottom-[0px] right-0 bg-[#fff] rounded-full  w-[15px] h-[15px] flex justify-center items-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={15}
                                            height={15}
                                            viewBox="0 0 15 15"
                                            fill="none"
                                        >
                                            <path
                                                d="M7.46792 5.45802C7.56356 5.45757 7.65604 5.47732 7.74851 5.49589C8.40297 5.62764 9.03292 5.82935 9.64722 6.0774C10.2459 6.31921 10.8287 6.59251 11.4171 6.85482C11.4602 6.87413 11.4617 6.89047 11.4411 6.92582C11.2 7.33904 10.9653 7.75538 10.7184 8.16578C10.3918 8.70882 10.0502 9.24503 9.80119 9.82624C9.70697 10.0462 9.6322 10.2723 9.56802 10.5013C9.49056 10.7777 9.30181 10.9353 9.00462 10.9818C8.56911 11.05 8.13897 11.1436 7.70662 11.2259C7.65193 11.2363 7.64671 11.2232 7.64213 11.1804C7.60292 10.8118 7.56166 10.4432 7.52088 10.0747C7.5008 9.89293 7.48025 9.71127 7.46002 9.52962C7.45796 9.51045 7.46255 9.48372 7.43488 9.48238C7.40342 9.4809 7.41149 9.51001 7.40959 9.52739C7.36707 9.91298 7.32549 10.2987 7.28297 10.6843C7.26589 10.8385 7.24598 10.9922 7.22985 11.1464C7.22606 11.1825 7.21578 11.1941 7.17326 11.1941C6.59611 11.195 6.04678 11.0744 5.51626 10.8672C5.432 10.8342 5.40845 10.7638 5.38774 10.6917C5.33131 10.4952 5.27313 10.2993 5.19773 10.1082C5.03459 9.69464 4.83462 9.29701 4.60825 8.91112C4.28371 8.35798 3.95569 7.80648 3.62957 7.25408C3.56729 7.14847 3.50864 7.04109 3.44541 6.93607C3.42201 6.89731 3.41901 6.88007 3.46991 6.85542C4.11567 6.54261 4.76648 6.2396 5.44054 5.98368C5.9788 5.77929 6.53272 5.61828 7.10196 5.50881C7.22226 5.48564 7.34367 5.45995 7.46808 5.45802H7.46792ZM8.93206 6.64406C8.68893 6.6399 8.49039 6.81695 8.4858 7.04183C8.48153 7.25527 8.6638 7.4552 8.86804 7.46099C9.13124 7.46842 9.35192 7.28527 9.35603 7.05594C9.35999 6.83611 9.16634 6.64807 8.93206 6.64406ZM9.86758 7.07584C9.68784 7.07614 9.56233 7.19482 9.56154 7.36548C9.56059 7.54045 9.68769 7.66507 9.86742 7.66552C10.0434 7.66597 10.175 7.54031 10.1758 7.37128C10.1766 7.19809 10.0487 7.07554 9.86774 7.07584H9.86758ZM10.5555 7.76266C10.654 7.76355 10.7182 7.70488 10.7211 7.6116C10.7239 7.52085 10.6561 7.45089 10.5647 7.45059C10.4691 7.45015 10.3992 7.51431 10.3981 7.60358C10.397 7.69538 10.4628 7.76192 10.5557 7.76266H10.5555Z"
                                                fill="#3559BD"
                                            />
                                            <path
                                                d="M10.0074 5.86139C9.83462 5.8354 9.68603 5.7644 9.53143 5.71152C9.06477 5.552 8.60397 5.37628 8.11929 5.26815C7.60253 5.15289 7.08829 5.16759 6.57595 5.2986C6.13728 5.41074 5.71489 5.56581 5.28902 5.71256C5.15118 5.76009 5.01712 5.81728 4.87438 5.85263C4.83185 5.86317 4.81446 5.86065 4.8151 5.81163C4.81747 5.59403 4.81668 5.37628 4.81431 5.15853C4.81383 5.11367 4.82521 5.09466 4.87691 5.08768C5.03957 5.0654 5.08431 5.00465 5.06091 4.85493C5.05301 4.80398 5.03182 4.75452 5.03989 4.70149C5.044 4.67446 5.01902 4.66347 5.00195 4.64921C4.88023 4.54761 4.75914 4.44512 4.63536 4.3459C4.60027 4.31783 4.58161 4.29006 4.58414 4.2455C4.58794 4.17895 4.58936 4.11167 4.58414 4.04527C4.57971 3.98972 4.59742 3.97427 4.65749 3.97472C5.06818 3.97739 5.47903 3.97606 5.88973 3.97606C5.96608 3.97606 6.04275 3.9716 6.11863 3.97739C6.18139 3.98215 6.19166 3.95957 6.1904 3.90654C6.1866 3.7433 6.19198 3.57992 6.18755 3.41668C6.18581 3.35221 6.19972 3.3289 6.27576 3.33008C6.57848 3.33484 6.88137 3.32949 7.18409 3.3338C7.25665 3.33484 7.27009 3.31404 7.26882 3.25092C7.26471 3.02143 7.26835 2.79165 7.26613 2.56217C7.26566 2.51523 7.27593 2.49547 7.3311 2.50156C7.38296 2.50736 7.43702 2.50795 7.48871 2.50141C7.5502 2.49354 7.55669 2.51894 7.55621 2.56707C7.554 2.79715 7.55795 3.02722 7.55352 3.2573C7.55226 3.32147 7.57439 3.33395 7.63778 3.33335C7.94319 3.33023 8.24876 3.33409 8.55402 3.33038C8.62183 3.32949 8.63669 3.3485 8.63495 3.40881C8.63037 3.57204 8.63638 3.73543 8.63179 3.89867C8.63005 3.95927 8.64618 3.97799 8.7132 3.97754C9.19234 3.97487 9.67164 3.97724 10.1509 3.97487C10.2164 3.97457 10.2317 3.98645 10.2412 4.05329C10.2676 4.23747 10.2058 4.37279 10.0384 4.46919C10.0096 4.48567 9.98844 4.5139 9.95967 4.53009C9.79922 4.6195 9.76349 4.76507 9.75574 4.9234C9.75147 5.01015 9.81297 5.07179 9.93295 5.08664C9.99381 5.09422 10.0093 5.11397 10.0085 5.16908C10.0054 5.39871 10.0072 5.62834 10.0072 5.86169L10.0074 5.86139ZM7.41236 5.06139C7.53329 5.06139 7.65406 5.06065 7.77499 5.06184C7.81515 5.06228 7.83728 5.05664 7.83554 5.00955C7.83143 4.89607 7.83159 4.7823 7.83491 4.66867C7.83617 4.6247 7.82005 4.61445 7.77658 4.61475C7.53471 4.61623 7.29285 4.61668 7.05099 4.6146C7.00056 4.61416 6.98854 4.63168 6.98949 4.67535C6.99218 4.78408 6.99329 4.8931 6.98918 5.00183C6.98712 5.05367 7.00957 5.06317 7.05778 5.06213C7.17603 5.05961 7.29427 5.06139 7.41252 5.06154L7.41236 5.06139ZM8.80173 5.05693C8.90938 5.05693 9.01719 5.05545 9.12484 5.05768C9.16658 5.05857 9.18602 5.05099 9.1846 5.00584C9.18128 4.89251 9.18254 4.77903 9.18412 4.66555C9.1846 4.63183 9.17527 4.61683 9.13623 4.61698C8.91839 4.61757 8.70071 4.61683 8.48288 4.61505C8.4462 4.61475 8.43134 4.62515 8.43182 4.66139C8.43356 4.77725 8.43419 4.8931 8.43166 5.00881C8.43071 5.04906 8.44636 5.05872 8.48652 5.05797C8.59148 5.05575 8.6966 5.05723 8.80173 5.05708V5.05693ZM6.00766 5.05693C6.11562 5.05693 6.22359 5.0553 6.3314 5.05768C6.37393 5.05857 6.38958 5.04921 6.39163 5.00539C6.39701 4.89162 6.39353 4.77843 6.38847 4.66495C6.38673 4.62648 6.37409 4.6143 6.33314 4.61475C6.12021 4.61713 5.90712 4.61757 5.69418 4.61698C5.65561 4.61698 5.63711 4.62455 5.63806 4.6657C5.64059 4.77947 5.64043 4.89325 5.63806 5.00703C5.63727 5.04579 5.65039 5.05857 5.69181 5.05768C5.79709 5.0553 5.90237 5.05693 6.00766 5.05693Z"
                                                fill="#3559BD"
                                            />
                                            <path
                                                d="M10.9366 12.1867C10.4975 12.1811 10.0806 12.0049 9.71781 11.7039C9.6647 11.6597 9.61142 11.615 9.56432 11.5656C9.52353 11.5227 9.50124 11.5218 9.46773 11.5735C9.35913 11.7414 9.22255 11.888 9.06415 12.0164C8.78008 12.2465 8.44763 12.3812 8.08247 12.4444C7.5842 12.5309 7.08783 12.5192 6.60331 12.3726C6.30802 12.2831 6.04465 12.1362 5.81939 11.9313C5.69277 11.816 5.58417 11.688 5.48663 11.5512C5.46007 11.514 5.44664 11.5146 5.41628 11.5491C5.21505 11.7768 4.97635 11.9592 4.68042 12.0687C4.42733 12.1622 4.16571 12.1988 3.89349 12.1756C3.60579 12.1511 3.32662 12.0985 3.06705 11.9754C2.80638 11.8515 2.61763 11.6636 2.50824 11.4069C2.49559 11.3771 2.49701 11.3579 2.5193 11.3342C2.54317 11.3088 2.56499 11.3192 2.58996 11.3281C2.85222 11.4222 3.10957 11.5292 3.38764 11.58C3.87516 11.6691 4.35414 11.6338 4.82759 11.5007C4.97856 11.4582 5.12636 11.4077 5.27338 11.3548C5.41881 11.3025 5.5565 11.3122 5.69862 11.379C6.09429 11.5651 6.51494 11.6756 6.95441 11.7238C7.51022 11.7845 8.05449 11.7293 8.59165 11.5885C8.83746 11.524 9.07316 11.4343 9.31091 11.3492C9.45603 11.2972 9.59909 11.3052 9.73915 11.361C10.0254 11.4753 10.3228 11.561 10.6287 11.6005C11.0292 11.6523 11.4309 11.6343 11.8236 11.5258C11.9926 11.4791 12.1551 11.4172 12.3144 11.3478C12.3576 11.3291 12.4017 11.3147 12.4468 11.3007C12.5098 11.2813 12.5054 11.3055 12.4923 11.3493C12.4121 11.6182 12.2262 11.8074 11.973 11.9372C11.6673 12.0939 11.3403 12.1873 10.9365 12.1867H10.9366Z"
                                                fill="#3559BD"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#15194B]">{contact?.userName} {contact?.userId === userID && "(You)"}</p>
                                    <div className="flex space-x-2 text-xs items-center">
                                        {contact?.role &&
                                            <span className="bg-[#376AFA] text-[13px] text-[#fff] rounded-[14px]  py-[4px] px-[8px]">
                                                {contact?.role}
                                            </span>}
                                        <span className="text-[#404585]  font-normal tracking-[-0.395px]  text-[13px] ">
                                            {contact?.rank}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* ---Designation---- */}
                            {selectedContactDetails?.channelOwner?.userId === contact?.userId ?
                                <span className='bg-[#E7E7FF] text-size-13 text-[#404585] py-[5px] px-[8px] rounded-[11px]'>Group Owner</span>
                                : (isGroupOwner || isChannelAdmin) ?
                                    <a src="#" className='relative group'><span className=''>
                                        <img src={ImagePath.options} alt="threedots"
                                            onClick={() => {
                                                setSelectedUserId(prev => prev === contact?.userId ? null : contact?.userId)
                                                setSelectedUser(prev => prev === contact ? null : contact)
                                            }}
                                        /></span>
                                        {selectedUserId === contact?.userId &&
                                            <div class="w-[248px] px-[20px] py-[25px] bg-[#fff] flex flex-col gap-[12px]  rounded-[10px] shadow-md shadow-[rgba(37,73,242,0.15)] absolute top-3 right-0 mt-[12px] z-40">
                                                <button class="w-full flex items-center space-x-2 bg-[#F9F9FD] text-[16px] font-normal p-[12px]  rounded-[8px] m-0"
                                                    onClick={() => setOpenAdminModal(true)}
                                                >
                                                    <img src={ImagePath.infoicon} alt="threedots" />
                                                    <span class="text-primary-blue text-[14px]">{isUserAlreadyAdmin(contact?.userId) ? 'Remove Admin' : 'Make Admin'}</span>
                                                </button>
                                                <button class="w-full flex items-center space-x-2 bg-[#F9F9FD] text-[16px] font-normal p-[12px]  rounded-[8px] m-0"
                                                    onClick={() => setOpenRemoveModal(true)}
                                                >
                                                    <img src={ImagePath.removeicon} alt="threedots" />
                                                    <span class="text-primary-blue text-[14px]"> Remove User</span>
                                                </button>
                                            </div>}
                                    </a>
                                    : ""
                            }
                        </div>))}

                {selectedGroupChatParticipants.length > 2 && (
                    <p
                        onClick={() => setShowAll(!showAll)}
                        className="text-[#376AFA] text-[14px] cursor-pointer font-medium"
                    >
                        {showAll ? 'Show Less' : `View All Members (${selectedGroupChatParticipants.length})`}
                    </p>
                )}
            </div>

            <UserConfirmationModal
                selectedUser={selectedUser}
                title="Remove User"
                type={"remove"}
                isOpen={openRemoveModal}
                onClose={closeRemoveModal}
                onConfirm={() => handleRemoveUser(selectedUserId)} selectedContactDetails={selectedContactDetails} />
            <UserConfirmationModal
                selectedUser={selectedUser}
                title={isUserAlreadyAdmin(selectedUserId) ? "Remove Admin" : "Make Admin"}
                type={isUserAlreadyAdmin(selectedUserId) ? "remove admin" : "make admin"}
                isOpen={openAdminModal}
                onClose={closeAdminModal}
                onConfirm={() => toggleAdmin(selectedUserId)}
                selectedContactDetails={selectedContactDetails}
                isUserAlreadyAdmin={isUserAlreadyAdmin}
            />
        </>
    )
}

export default Memberlist